import { atom } from 'recoil';

export type IncidentTableSort = { field: string; order: 'asc' | 'desc' };
export const sortState = atom<IncidentTableSort>({
  key: 'incidentTable.sort',
  default: { field: 'count', order: 'desc' },
});
